<form class="itinerary-model-content-inner" [formGroup]="itineraryDetailsForm" *ngIf="itineraryDetailsForm">
  <div class="itinerary-model-content">
    <div class="form-container p-2">
      <div class="form-table-grid-container">
        <!-- Form fields container -->
        <div class="shadow-box-container">
          <div class="box-title-container">
            <div class="">
              <div class="d-flex align-items-center">
                <div class="icon-container">
                  <ion-icon name="reader"></ion-icon>
                </div>
                <div>
                  <p class="title">Details</p>
                  <p class="sub-title">itinerary Information</p>
                </div>
              </div>
            </div>
          </div>
          <div class="shadow-inner-container">
            <div class="row mt-2" *ngIf="!leadId">
              <div class="col-12">
                <!-- Radio Buttons for Domestic / International -->
                <div class="radio-group">
                  <div class="input-container">
                    <input type="radio" id="domestic" formControlName="itineraryType" value="domestic">
                    <label for="domestic" class="label">Domestic</label>
                  </div>

                  <div class="input-container">
                    <input type="radio" id="international" formControlName="itineraryType" value="international">
                    <label for="international" class="label">International</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="input-container">
                  <label for="" class="label">Itinerary Name* <span class="warning-message"
                      *ngIf="itineraryDetailsForm.get('itineraryName')?.errors?.['maxLengthExceeded']">The maximum length
                      is {{ itineraryDetailsForm.get('itineraryName')?.errors?.['maxLengthExceeded'].maxLength
                      }}</span></label>
                  <div
                    [ngClass]="{ 'invalid-input': itineraryDetailsForm.get('itineraryName')?.invalid && itineraryDetailsForm.get('itineraryName')?.touched }">
                    <input class="input-text input" type="text" placeholder="Ex - Goa group trip"
                      formControlName="itineraryName">
                  </div>
                </div>
              </div>
            </div>

            <ng-container formArrayName="destinationDaysArray">
              <div class="destinations-days-row row" *ngFor="let item of destinationDaysArray.controls; let i = index"
                [formGroupName]="i"
                draggable="true"
                (dragstart)="onDragStart($event, i)"
                (dragover)="onDragOver($event, i)"
                (drop)="onDrop(i)"
                (dragend)="onDragEnd()"
                [ngClass]="{'drag-over': dragOverIndex === i, 'dragging': draggingIndex === i}">
                <div class="col-7">
                  <div class="input-container">
                    <label for="" class="label">Destination {{i+1}}*<span class="drag-handle" title="Drag to reorder" (mousedown)="onHandleMouseDown()" (mouseup)="onHandleMouseUp()">⠿</span></label>
                    <div [ngClass]="{ 'invalid-input': item.get('location')?.invalid && item.get('location')?.touched }">
                      <app-locations-autocomplete (predictionSelected)="handlePrediction($event)"
                        formControlName="location" [placeHolder]="'Enter Destination' "draggable="false"></app-locations-autocomplete>
                    </div>
                  </div>

                </div>

                <div class="col-4">
                  <div class="input-container">
                    <label for="" class="label">Nights*</label>
                    <div [ngClass]="{ 'invalid-input': item.get('days')?.invalid && item.get('days')?.touched }">
                      <app-increment-number-input formControlName="days" [max]="365" draggable="false"></app-increment-number-input>
                    </div>
                  </div>
                </div>

                <div class="col-1 position-relative" style="width: 25px;">
                  <div class="btns-container">
                    <ion-button class="add-btn action-btn" (click)="addDestination()"
                      *ngIf="i+1 === destinationDaysArray.controls.length"><ion-icon
                        name="add-outline"></ion-icon></ion-button>
                    <ion-button class="delete-btn action-btn" (click)="removeDestination(i)"
                      *ngIf="destinationDaysArray.controls.length !== 1"><ion-icon
                        name="trash-outline"></ion-icon></ion-button>
                  </div>
                </div>

                <div class="col-12">
                  <div *ngIf="item.get('destinationDays')?.invalid && item.get('destinationDays')?.touched">
                    <p class="text-danger warning-message">Please enter a valid destination and number of days</p>
                  </div>
                </div>
              </div>
            </ng-container>


            <div class="row" *ngIf="leadId">

              <div class="col-6">
                <div class="input-container">
                  <label for="" class="label">Trip Start date*</label>
                  <div
                    [ngClass]="{ 'invalid-input': itineraryDetailsForm.get('startDate')?.invalid && itineraryDetailsForm.get('startDate')?.touched }">
                    <app-date-picker [minDate]="today()" formControlName="startDate"></app-date-picker>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="input-container">
                  <label for="" class="label">Trip end date</label>
                  <div
                    [ngClass]="{ 'invalid-input': itineraryDetailsForm.get('endDate')?.invalid && itineraryDetailsForm.get('endDate')?.touched }">
                    <app-date-picker [minDate]="today()" formControlName="endDate"></app-date-picker>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="input-container">
                  <div class="d-flex align-items-center p-1 pb-0">
                    <input type="checkbox" name="" id="" class="me-1" formControlName="flexibleDays">
                    <label for="" class="label">Flexible Days</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" *ngIf="leadId">
              <div class="col-12">
                <div class="input-container">
                  <label for="" class="label">No Of Passengers* <span class="text-danger warning-message"
                      *ngIf="itineraryDetailsForm.get('noOfGuests')?.hasError('noOfAdultsInvalid') && itineraryDetailsForm.get('noOfGuests')?.touched">Adults
                      cannot be 0</span><span class="text-danger warning-message"
                      *ngIf="itineraryDetailsForm.get('noOfGuests')?.hasError('childrenAgeInvalid') && itineraryDetailsForm.get('noOfGuests')?.touched">Select
                      age for all children</span></label>
                  <div
                    [ngClass]="{ 'invalid-input': itineraryDetailsForm.get('noOfGuests')?.invalid && itineraryDetailsForm.get('noOfGuests')?.touched }">
                    <app-no-of-guests-input formControlName="noOfGuests"></app-no-of-guests-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="hotel-pref" *ngIf="leadId">
              <div class="ion-no-padding mt-1">
                <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Hotel Preference</ion-title>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Hotel Category</label>
                    <div>
                      <select class="input" formControlName="hotelType">
                        <option value="" hidden>select</option>
                        <option *ngFor="let item of accommodationType" [ngValue]="item.name">{{item.name}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Rooms</label>
                    <div>
                      <app-increment-number-input [max]="100" formControlName="noOfRooms"></app-increment-number-input>

                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Budget</label>
                    <div>
                      <app-select-text-input formControlName="budget"></app-select-text-input>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="input-container">
                  <label for="" class="label">Note</label>
                  <div
                    [ngClass]="{ 'invalid-input': itineraryDetailsForm.get('sectionNote')?.invalid && itineraryDetailsForm.get('sectionNote')?.touched }">
                    <app-text-formatting-input formControlName="sectionNote"></app-text-formatting-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Recommended itinerary container -->
        <div class="shadow-box-container">
          <div class="box-title-container">
            <div class="">
              <div class="d-flex align-items-center">
                <div class="icon-container">
                  <ion-icon name="bulb"></ion-icon>
                </div>
                <div>
                  <p class="title">{{showWebsiteSettings ? "Website" :"Recommendations"}}</p>
                  <p class="sub-title">{{showWebsiteSettings ? "Website Builder Information" : "Itinerary & DMC options"}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="website-configration-container my-2 px-3" *ngIf="showWebsiteSettings">
            <div class="row">
              <div class="col-12">
                <div class="input-container">
                  <div class="d-flex align-items-center"><input type="checkbox" class="me-1 align-items-middle"
                      formControlName="showInWebsite"><label for="" class="label">Show Itinerary In Website</label>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="input-container">
                  <label for="" class="label">Approx Itinerary Starting Cost <span *ngIf="itineraryDetailsForm.get('showInWebsite')?.value">*</span></label>
                  <div [ngClass]="{'invalid-input': itineraryDetailsForm.get('itineraryCost')?.invalid && itineraryDetailsForm.get('itineraryCost')?.touched}">
                    <app-cost-currency-input formControlName="itineraryCost"
                      [currencies]="['INR','USD','EUR','GBP','AUD','CAD','JPY']">
                    </app-cost-currency-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="input-container">
                  <label for="" class="label">Upload Banner Image <span *ngIf="itineraryDetailsForm.get('showInWebsite')?.value">*</span></label>
                  <div
                    [ngClass]="{ 'invalid-input': itineraryDetailsForm.get('imageDoc')?.invalid && itineraryDetailsForm.get('imageDoc')?.touched }">
                    <div class="file-view" *ngIf="itineraryDetailsForm.get('imageDoc')?.value">
                      <div class="w-100">
                        <img [src]="getImgUrl(itineraryDetailsForm.get('imageDoc')?.value)" alt="" class="w-100">
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex">
                          <label for="organizationImageInput" class="unfilled-gray-btn px-2 my-1">
                            Reupload
                          </label>
                          <ion-button class="unfilled-red-btn" (click)="deleteBannerImage()">Delete</ion-button>
                        </div>
                      </div>
                    </div>
                    <div class="w-50" [ngClass]="{'d-none' : itineraryDetailsForm.get('imageDoc')?.value}">
                      <input type="file" id="organizationImageInput" class="input" accept="image/*"
                        (change)="onBannerChange($event)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="showRecommendedItineraries">
            <div class="px-2">
              <div class="input-container">
                <label for="" class="label">Recommended Itineraries</label>
              </div>
              <div class="recommeneded-itinerary-section">
                <ng-container *ngIf="recommenedItinerariesData.length === 0">
                  <p class="text-center py-3" style="font-size: 12px;">Select desinations and no of days to get recommended
                    itineraries</p>
                </ng-container>
                <div class="itinerary-card-container">
                  <div class="itinerary-card" *ngFor="let itinerary of recommenedItinerariesData">
                    <div class="item">
                      <p class="itinerary-name"><span (click)="!checkIfRecommendedItineraryIsSelected(itinerary) ? openInventoryItinerary(itinerary): null">
                        <span [ngClass]="{'clickable-text': !checkIfRecommendedItineraryIsSelected(itinerary)}">
                          {{this._globalService.trimString(itinerary.itineraryName, 15)}}</span>
                      </span></p>
                      <p class="itinerary-type">{{itinerary.type}}</p>
                    </div>
                    <div class="item">
                      <p class="destination">{{getDestinationsArray(itinerary.destination)}}</p>
                      <p class="valid-dates" *ngIf="convertToDate(itinerary.validFrom)">{{convertToDate(itinerary.validFrom) ? (convertToDate(itinerary.validFrom) | date: "dd MMM,
                        yyy") : "--"}} to {{convertToDate(itinerary.validTo) ? (convertToDate(itinerary.validTo) | date: "dd MMM, yyy")
                        : "--"}}</p>
                    </div>
                    <div class="item">
                      <span 
                        [ngClass]="{'clickable-text create-btn': !checkIfRecommendedItineraryIsSelected(itinerary)}"
                        (click)="!checkIfRecommendedItineraryIsSelected(itinerary) ? createQuote(itinerary) : null">
                        {{!checkIfRecommendedItineraryIsSelected(itinerary) ? 'Create Quote':'Selected'}}
                      </span>
                      <span class="clickable-text create-btn"
                        *ngIf="tempRecommendedItineraryId && (checkIfRecommendedItineraryIsSelected(itinerary))"
                        (click)="unselectRecommendedItinerary()">Unselect</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="dashed-line my-2"></div>
          </div>
          <div *ngIf="showRecommendedDmcVendors" class="px-2">
            <div class="dmc-vendor-main-container">
              <div class="input-container">
                <div class="d-flex align-items-center justify-content-between">
                  <label for="" class="label">Recommendation DMC or Vendors</label>
                  <div class="search-container">
                    <input type="text" class="search-input" placeholder="Search" formControlName="dmcVendorSearch"
                      (keyup.enter)="searchDmcVendors()">
                    <ion-button class="search-button" (click)="searchDmcVendors()"><ion-icon
                        name="search-outline"></ion-icon></ion-button>
                  </div>
                </div>

              </div>
              <div class="recommeneded-itinerary-section">
                <table class="table custom-table">
                  <tbody>
                    <ng-container *ngIf="allVendorsData.data.length>0">
                      <tr *ngFor="let vendor of allVendorsData.data">
                        <td class="text-capitalize">
                          <input type="checkbox" [checked]="vendor.selected"
                            (change)="updateselection(vendor.id,$event)" />
                          <span class="badge" [ngClass]="vendor.type === 'DMC' ? 'dmc-badge' : 'vendor-badge'">
                            {{ vendor.type }}
                          </span>
                          <span>
                            {{vendor.organizationName}}
                          </span>
                        </td>
                        <td>{{vendor.rating}}</td>
                        <td>
                          <ion-button type="button" class="send-request-btn"
                            [ngClass]="vendor.request ? 'yellow-btn' : 'blue-btn'"
                            [disabled]="isdisabled || vendor.request"
                            (click)="sendemail(vendor)">{{vendor.request?'Request Sent':'Send
                            Request'}}</ion-button>
                        </td>
                      </tr>
                      <tr class="sticky-bottom" [ngClass]="{'search-row': isdisabled}" *ngIf="dmcSelectAll">
                        <td colspan="3">
                          <ion-button type="button" class="filled-blue-btn" [disabled]="!isdisabled"
                            (click)="sendemail()">Send Request</ion-button>
                        </td>
                      </tr>
                    </ng-container>

                    <tr *ngIf="allVendorsData.data.length === 0">
                      <td colspan="3" class="text-center py-3">Select desinations get recommended vendors/dmcs</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>

  <div class="ion-padding-horizontal justify-content-between itinerary-model-footer">
    <div class="d-flex align-items-center">
      <ion-button class="unfilled-blue-btn" type="button" (click)="goPrevious()" *ngIf="leadId"
        [disabled]="formDataModified()">
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
        Reset
      </ion-button>
    </div>
    
    <div class="d-flex align-items-center">
      <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
        Save
      </ion-button>
      <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
        Save & Next
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="!itineraryId || formDataModified()">
        <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </div>
</form>